module.exports = __webpack_public_path__ + "img/header-engagementRingsExclusive.9a0d107.jpg";